import React from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  CardSubtitle,
} from "reactstrap"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

export default function ProductManagement() {
  const data = {
    columns: [
      {
        label: "Product Group",
        field: "ProductGroup",
        sort: "asc",
        attributes: { width: "17.6%" },
      },
      {
        label: "Product Category",
        field: "ProductCategory",
        sort: "asc",
        attributes: { width: "17.6%" },
      },
      {
        label: "Product Name",
        field: "ProductName",
        sort: "asc",
        attributes: { width: "17.6%" },
      },
      {
        label: "Packaging Size",
        field: "PackagingSize",
        sort: "asc",
        attributes: { width: "17.6%" },
      },
      {
        label: "Price",
        field: "Price",
        sort: "asc",
        attributes: { width: "17.6%" },
      },
      {
        label: "Assign Role",
        field: "AssignRole",
        sort: "asc",
        attributes: { width: "12%" },
      },
    ],
    rows: [
      {
        ProductGroup: "Fruits & Vegetables",
        ProductCategory: "Dry Fruits",
        ProductName: "Pista",
        PackagingSize: "500GM",
        Price: "25$",
        AssignRole: (
          <>
          
              <Button
                className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
                style={{ width: "25px", height: "25px", padding: "0px" }}
                title="Edit"
                onClick={() => {}}
                href="/add-product"
              >
                <i className="fas fa-edit"></i>
              </Button>
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Delete"
              onClick={() => {}}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </Button>{" "}
            <Button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary"
              style={{
                width: "25px",
                height: "25px",
                padding: "0px",
              }}
              title="Active / Inactive"
              onClick={() => {}}
            >
              <i className="fas fa-bullseye" style={{ color: "#38e038" }}></i>
            </Button>
          </>
        ),
      },
    ],
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Product Management | Virtual Supermarket</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}

          <Button
            href="/add-product"
            color="primary"
            style={{ float: "right", marginTop: "1.9rem" }}
          >
            Add Product
          </Button>

          <Breadcrumbs
            maintitle="Dashboard"
            title="Product Management"
            breadcrumbItem="Product List"
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <MDBDataTable
                    responsive
                    bordered
                    noBottomColumns
                    theadColor="btn-primary"
                    data={data}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
